import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ContentsComponent } from './components/contents/contents.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordComponent } from 'src/app/core/components/change-password/change-password.component';
import { CoreService } from './Services/core.service';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { CoreComponent } from './core.component';
import { LoaderModules } from '../loader/loader.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

const routes: Routes = [
  { path: 'login/:type',  component:  LoginComponent},
    { path: 'forgotpassword',  component:  ForgotPasswordComponent},
    { path: 'signup/:type',  component:  SignUpComponent},
    { path: 'changepassword/:Id',  component:  ChangePasswordComponent},
    { path: 'resetpassword',  component:  ResetPasswordComponent},
];


@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ContentsComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    SignUpComponent,
    CoreComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    LoaderModules,
    MatIconModule,
    MatTooltipModule,
    MatAutocompleteModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  providers:[CoreService]
})
export class CoreModule { }
